import { render, staticRenderFns } from "./SavePageHeader.vue?vue&type=template&id=dc57d10a"
import script from "./SavePageHeader.vue?vue&type=script&lang=js"
export * from "./SavePageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports